
 import { Pipe, PipeTransform } from '@angular/core';
import { Question } from '../../models/question.model';

 @Pipe({
     name: 'filterquestions' 
 })
 export class FilterQuestionsPipe implements PipeTransform {
     transform(items: Question[],filter: string ,type: string): Question[] {
         if (!items || !filter) {
             return items;
         }
         
         return items.filter(item => item.idTopicDetails == filter && item.format==type);
     }
 }